import { useTranslation } from 'react-i18next';
import { LOCALE_NAMES, LOCALE_READY, LOCALES, normaliseLocale } from '../../i18n/config.js';

/**
 * Language switcher.
 *
 * A native `<select>`, as the design specifies: it scales past the two
 * languages the old inline pair could hold, and gets keyboard behaviour and
 * the platform picker on touch devices for free.
 */
export function LocaleSelect({ variant }: { variant: 'header' | 'footer' }) {
  const { t, i18n } = useTranslation(['common']);
  const active = normaliseLocale(i18n.resolvedLanguage);

  return (
    <span className={`localeselect localeselect--${variant}`}>
      <label className="visually-hidden" htmlFor={`locale-${variant}`}>
        {t('common:localeLabel')}
      </label>
      <select
        id={`locale-${variant}`}
        className="localeselect__input"
        value={active}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
      >
        {LOCALES.map((locale) => (
          <option key={locale} value={locale} disabled={!LOCALE_READY[locale]}>
            {LOCALE_NAMES[locale]}
          </option>
        ))}
      </select>
      <span className="localeselect__chevron" aria-hidden="true">
        ▾
      </span>
    </span>
  );
}
